import StoreLocator from 'features/store/pages/store-locator';
import StoreLocatorExperiment from 'features/store/pages/store-locator-experiment';

import { useEnableMapListExperiment } from 'experiments/use-enable-map-list-experiment';

export default function StoreLocatorPage() {
  const enableMapListExperiment = useEnableMapListExperiment();

  return enableMapListExperiment ? <StoreLocatorExperiment /> : <StoreLocator />;
}
